import { render } from "./MomentFrom.vue?vue&type=template&id=965c21ac"
import script from "./MomentFrom.vue?vue&type=script&lang=js"
export * from "./MomentFrom.vue?vue&type=script&lang=js"
script.render = render

export default script